module.exports = __webpack_public_path__ + "static/media/love.58244416.svg";